"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifyIssueActionLabel = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill"));
const react_1 = __importDefault(require("react"));
function NotifyIssueActionLabel(props) {
    var _a;
    const { action } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    return (react_1.default.createElement(react_1.default.Fragment, null, (_a = config === null || config === void 0 ? void 0 : config.notifyTo) === null || _a === void 0 ? void 0 :
        _a.map(n => (react_1.default.createElement(DataPill_1.default, { value: n.title, type: n.type }))),
        (config === null || config === void 0 ? void 0 : config.notifyPlaceAdmin) && react_1.default.createElement(DataPill_1.default, { value: lib_i18n_1.default.t('place-admin') }),
        (config === null || config === void 0 ? void 0 : config.notifyPrimaryAdmin) && react_1.default.createElement(DataPill_1.default, { value: lib_i18n_1.default.t('primary-admin') }),
        (config === null || config === void 0 ? void 0 : config.notifyAssignee) && react_1.default.createElement(DataPill_1.default, { value: lib_i18n_1.default.t('assignee') }),
        (config === null || config === void 0 ? void 0 : config.notifyCreator) && react_1.default.createElement(DataPill_1.default, { value: lib_i18n_1.default.t('creator') })));
}
exports.NotifyIssueActionLabel = NotifyIssueActionLabel;
exports.default = NotifyIssueActionLabel;
